import * as Yup from "yup";

export const salaryDisbursementSchema = Yup.object({
  percentage: Yup.number().required("Percentage is required"),
  chargeDeductionPeriod: Yup.string().required(
    "Charge Deduction Period is required"
  ),
});

export const addCurrencyRuleSchema = Yup.object().shape({
  revenueLine: Yup.string().required("Revenue line is required."),
  costCurrency: Yup.string().required("Cost currency is required."),
  effectiveDate: Yup.string().required("Effective date is required."),
  sellCurrency: Yup.string().required("Sell currency is required."),
  status: Yup.string().required("Status is required."),
  sellRate: Yup.number()
    .typeError("Sell rate must be a number")
    .required("Sell rate is required."),
  baseCostAmount: Yup.number()
    .typeError("Base cost must be a number")
    .required("Base cost is required."),
  externalSupplierCost: Yup.number()
    .typeError("External supplier cost must be a number")
    .nullable(),
});

export const editCurrencyRuleSchema = addCurrencyRuleSchema.shape({
  reason: Yup.string()
    .required("Reason field is required.")
    .min(5, "Reason must be at least 5 characters long"),
});

export const editConversionRateSchema = Yup.object({
  exchangeRate: Yup.number()
    .required("Exchange rate is required")
    .positive("Exchange rate must be positive")
    .typeError("Exchange rate must be a valid number"),
  effectiveDate: Yup.date()
    .required("Effective date is required")
    .min(
      new Date(new Date().setHours(0, 0, 0, 0)),
      "Effective date cannot be in the past"
    )
    .typeError("Please enter a valid date"),
  expiryDate: Yup.date()
    .required("Expiry date is required")
    .min(Yup.ref("effectiveDate"), "Expiry date must be after effective date")
    .typeError("Please enter a valid date"),
  source: Yup.string().required("Source is required"),
});

export const conversionRateSchema = Yup.object({
  application: Yup.string().required("Application is required"),
  fromCurrency: Yup.string().required("From currency is required"),
  toCurrency: Yup.string()
    .required("To currency is required")
    .test(
      "different-currencies",
      "To currency must be different from From currency",
      function (value) {
        return value !== this.parent.fromCurrency;
      }
    ),
  exchangeRate: Yup.number()
    .required("Exchange rate is required")
    .positive("Exchange rate must be positive")
    .typeError("Exchange rate must be a valid number"),
  effectiveDate: Yup.date()
    .required("Effective date is required")
    .min(
      new Date(new Date().setHours(0, 0, 0, 0)),
      "Effective date cannot be in the past"
    )
    .typeError("Please enter a valid date"),
  expiryDate: Yup.date()
    .required("Expiry date is required")
    .min(Yup.ref("effectiveDate"), "Expiry date must be after effective date")
    .typeError("Please enter a valid date"),
  source: Yup.string().required("Source is required"),
});
